(function ($) {
    $(() => {
        $('.js-youtube-player').on('click', function () {
            $(this).find('.play').hide();
            $(this).html(
                `<iframe src="https://www.youtube.com/embed/${$(this).data(
                    'id'
                )}?autoplay=1&amp;rel=0&amp;enablejsapi=1" frameborder="0" allow="autoplay" allowfullscreen="1"></iframe>`
            );
        });

        const videoObserver = new IntersectionObserver((entries) => {
            $.each(entries, (i, entry) => {
                if (entry.intersectionRatio > 0) {
                    $(entry.target)
                        .find('.youtube-player')
                        .each(function () {
                            if (!$(this).hasClass('wasPlayed')) {
                                $(this).html(
                                    `<iframe src="https://www.youtube.com/embed/${$(this).data(
                                        'id'
                                    )}?autoplay=1&amp;rel=0&amp;enablejsapi=1" frameborder="0" allow="autoplay" allowfullscreen="1"></iframe>`
                                );
                                $(this).addClass('wasPlayed');
                            } else {
                                $(this)
                                    .find('iframe')[0]
                                    .contentWindow.postMessage(
                                        '{"event":"command","func":"' +
                                        'playVideo' +
                                        '","args":""}',
                                        '*'
                                    );
                            }
                        });
                } else {
                    $(entry.target)
                        .find('.youtube-player')
                        .each(function () {
                            if ($(this).find('iframe').length == 1) {
                                $(this)
                                    .find('iframe')[0]
                                    .contentWindow.postMessage(
                                        '{"event":"command","func":"' +
                                        'pauseVideo' +
                                        '","args":""}',
                                        '*'
                                    );
                            }
                        });
                }
            });
        });
    });
})(jQuery);
